import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../Common/Configurations/AuthContext';
import apiService from '../../Common/Configurations/APIService';
import config from '../../Common/Configurations/APIConfig';
import moment from 'moment';
import './MyBookings.css';

const MyFlightBookings = () => {
    const { user } = useAuth();
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [pageSize, setPageSize] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);

    useEffect(() => {
        const getBookings = async () => {
            if (!user?.id) {
                setLoading(false);
                setError("User not found. Please log in again.");
                return;
            }

            try {
                const response = await apiService.post(`${config.GETUSERFLIGHTBOOKINGS}/${user?.id}`, pageSize, pageNumber);
                setBookings(response);
            } catch (err) {
                setError("Could not fetch your flight bookings. Please try again later.");
                console.error("Failed to fetch flight bookings:", err);
            } finally {
                setLoading(false);
            }
        };

        getBookings();
    }, [user, pageSize, pageNumber]);

    const renderStatusBadge = (status) => {
        let badgeClass = 'bg-secondary';
        switch (status?.toUpperCase()) {
            case 'CONFIRMED':
            case 'SUCCESS':
                badgeClass = 'bg-success';
                break;
            case 'PENDING':
            case 'HOLD':
                badgeClass = 'bg-warning text-dark';
                break;
            case 'CANCELLED':
            case 'FAILED':
                badgeClass = 'bg-danger';
                break;
            default:
                break;
        }
        return <span className={`badge ${badgeClass}`}>{status}</span>;
    };


    const parsePnr = (pnr) => {
        if (!pnr || typeof pnr !== 'string') {
            return 'Pending';
        }
        try {
            const parsed = JSON.parse(pnr);
            // Get the first value from the parsed object, e.g., "EREB7M"
            const pnrValue = Object.values(parsed)[0];
            return pnrValue || 'Pending';
        } catch (error) {
            // If it's not a valid JSON, it might be an empty string or already formatted
            return pnr.trim() ? pnr : 'Pending';
        }
    };
return (
  <div className="main-content">
    <div className="bookings-card">
      {loading ? (
        <div className="text-center p-2">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2">Loading your bookings...</p>
        </div>
      ) : error ? (
        <div className="alert alert-danger">{error}</div>
      ) : (
        <div className="table-responsive">
          <table className="table table-hover align-middle">
            <thead className="table-light">
              <tr>
                <th>S No</th>
                <th>Booking No</th>
                <th>Journey</th>
                <th>Journey Details</th>
                <th>Departure</th>
                <th>Booking Status</th>
                <th>Payment Status</th>
                <th>Total Price</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {bookings.length > 0 ? (
                bookings.map((booking, index) => {
                  // Safely access nested properties from the response
                  const searchRequest = booking.flightSearchRequest;
                  const journeyPoints = searchRequest?.flightTravelerPoints?.[0];
                  const from = journeyPoints?.from;
                  const to = journeyPoints?.to;
                  const journeyType = searchRequest?.journeyType;

                  return (
                    <tr key={booking.flightBookingId}>
                      <td>{index + 1}</td>
                      <td>
                        <strong>{booking.bookingNo}</strong>
                        <br />
                        <small className="text-muted">
                          PNR: {parsePnr(booking.pnr)}
                        </small>
                      </td>
                      <td>
                        <strong>
                          {from} → {to}
                        </strong>
                      </td>
                      <td>
                        <strong>{journeyType}</strong>
                      </td>
                      <td>
                        {moment(booking.departureDate).format(
                          "DD MMM YYYY, h:mm A"
                        )}
                      </td>
                      <td>{renderStatusBadge(booking.bookingStatus)}</td>
                      <td>{renderStatusBadge(booking.paymentStatus)}</td>
                      <td>
                        <strong>{booking.totalPrice}</strong>
                      </td>
                      <td>
                        <Link
                          to={`/my-flight/booking/${booking.flightBookingId}`}
                          className="btn btn-sm btn-outline-primary"
                        >
                          View Details
                        </Link>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="9" className="text-center py-4">
                    No records found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  </div>
);
}
export default MyFlightBookings;